import { render, staticRenderFns } from "./jtMod.vue?vue&type=template&id=43855ea8&scoped=true"
import script from "./jtMod.vue?vue&type=script&lang=js"
export * from "./jtMod.vue?vue&type=script&lang=js"
import style0 from "./jtMod.vue?vue&type=style&index=0&id=43855ea8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43855ea8",
  null
  
)

export default component.exports